import { create } from 'zustand';
import { msgInfo } from './components/constants';

const initialState = {
  session_id: '',
  messages: [],
};

export const useSalesAssistStore = create((set, get) => ({
  ...initialState,
  setId: (id) => set(() => ({ session_id: id })),
  updateMessages: (newMessage) => {
    const temp = [newMessage, ...get().messages];
    return set({ messages: temp });
  },
  addUserMessage: (message) =>
    set((state) => ({ messages: [{ type: msgInfo.sender, text: message }, ...state.messages] })),
  startAIMessage: () =>
    set((state) => ({ messages: [{ type: msgInfo.recipient, text: '' }, ...state.messages] })),
  addToLastAIMessage: (textLine) =>
    set((state) => {
      const updatedMessages = [...state.messages];
      updatedMessages[0].text += textLine;
      return { messages: updatedMessages };
    }),
  reset: () => {
    set(initialState);
  },
}));
